import { constants as AUTH } from './auth';
import { constants as BREWERY } from './brewery';

export const initialState = null;

export function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case AUTH.LOGIN.SUCCESS:
      return payload ? payload.breweries : [];
    case AUTH.LOGOUT.SUCCESS:
      return initialState;
    case BREWERY.UPDATE.SUCCESS:
      return state.map(
        b =>
          b.id === payload.id
            ? {
                ...b,
                ...payload
              }
            : b
      );
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/breweries.js